import get from 'lodash/get';

/**
 * True if a feature flags are fetched.
 *
 * @param {Object} state The Redux state.
 * @returns {boolean}
 */
export default function isFeatureFlagReady(state) {
  return get(state, ['featureFlags', 'isReady'], false);
}
